<div class="cookie-container" [ngClass]="{ hidden: hidden() }">
    <mat-icon class="cookie-container__close-button" role="button" svgIcon="ico_close" (click)="close()"></mat-icon>
    <p class="body-1">
        We and our partners use cookies and other tools for advertising, to help stop fraud, and for other purposes. By
        using this site, you agree to how your information is used as outlined in our
        <a class="privacy-link" [routerLink]="privacyPolicyPath">Privacy Policy</a>.
    </p>
</div>
